import storyContent from '../story.json';
import * as dataManager from './dataManager.js';
import m from 'mithril';

const timeBasis = 60; //in ms per character
const timeCeiling = 3000; //never more than this time
const timeFloor = 1200; //never less than this
const timeLongPause = 5000;

let story;
let inTextMessage = false;
let data = {
  passages: [],
  choices: [],
  title: 'Intro',
  time: '12:34',
};

export const DIRECTIONS = {
  SENT: 'sent',
  RECEIVED: 'received',
  SYSTEM: 'system',
};

export function init() {
  if (!story) {
    story = new inkjs.Story(storyContent);
  }

  //set up observers
  if (story.variablesState['time']) {
    story.ObserveVariable('time', (name, val) => {
      data.time = val;
      m.redraw();
    });
  }

  if (story.variablesState['title']) {
    story.ObserveVariable('title', (name, val) => {
      data.title = val;
      m.redraw();
    });
  }

  return continueStory(true);
}

const visibleCb = (target) => {
  target.visible = true;
  m.redraw(); //tell mithril we changed things on it
};

export function continueStory(firstTime) {
  let hideTime = 0;
  // Generate story text - loop through available content
  while (story.canContinue) {
    // Get ink to generate the next paragraph
    let passageText = story.Continue();
    const tags = story.currentTags;
    let passageHideTime = passageText.length * timeBasis;

    //protective logic to keep time in reasonable bounds
    if (passageHideTime > timeCeiling) {
      passageHideTime = timeCeiling;
    } else if (passageHideTime < timeFloor) {
      passageHideTime = timeFloor;
    }

    hideTime += passageHideTime;

    let direction = DIRECTIONS.SENT;
    if (tags.includes('recv') || passageText[0] === '>') {
      direction = DIRECTIONS.RECEIVED;
      if (passageText[0] === '>') {
        passageText = passageText.substr(1);
        passageText = passageText.trim();
      }
    } else if (tags.includes('system')) {
      direction = DIRECTIONS.SYSTEM;
    }

    if (tags.includes('CLEAR')) {
      data.passages = [];
      m.redraw();
    }

    if (tags.includes('longpause')) {
      hideTime += timeLongPause;
    }

    let visible = direction == DIRECTIONS.SYSTEM ? true : false;

    const passage = {
      type: 'passage',
      text: passageText,
      visible,
      tags,
      direction,
      visibilityTimer: null,
    };

    if (!visible) {
      //if we need one, hook up a visibilityTimer handle
      passage.visibilityTimer = setTimeout(
        visibleCb.bind(this, passage),
        hideTime
      );
    }

    if (passage.text.trim().length > 0) data.passages.push(passage); //prevent empty choices from rendering a message bubble
  }

  if (story.currentChoices.length) {
    const isSystem = story.currentTags.includes('system');

    const styles = [];

    if (isSystem) {
      styles.push('choice-system');
    } else if (story.currentTags.includes('sceneChange')) {
      styles.push('choice-sceneChange');
    } else {
      styles.push('choice-conversation');
    }

    data.choiceBlock = {
      choices: story.currentChoices,
      visible: isSystem,
      visibilityTimer: null,
      styles: styles,
    };

    data.choiceBlock.visibilityTimer = setTimeout(
      visibleCb.bind(this, data.choiceBlock),
      hideTime
    );
  }

  return data;
}

export function getDataRef() {
  return data;
}

export function restart() {
  story.ResetState();
  return continueStory(true);
}

export function makeChoice(choiceIndex) {
  data.choiceBlock = {
    choices: [],
    visible: false,
    visibilityTimer: null,
    styles: [],
  };
  m.redraw();
  story.ChooseChoiceIndex(choiceIndex);
  return continueStory();
}
